export function getPlatformType() {
    const ua = window.navigator.userAgent.toLowerCase();
    // 2. 企业微信
    if (/wxwork|wecom/i.test(ua)) {
        return 'wecom';
    }
    // 3. 微信浏览器（公众号 H5 等）
    if (/micromessenger|weixin/i.test(ua)) {
        return 'weixin';
    }
    // 4. 快手（含快手小程序）
    if (/kuaishou|kwai|kuaishoumini/i.test(ua)) {
        return 'kuaishou';
    }
    // 5. 百度（含百度小程序）
    if (/baidu|baiduboxapp|baidubrowser|swan/i.test(ua)) {
        return 'baidu';
    }
    // 6. 微博
    if (/weibo|weibo__|\bweibo\b/i.test(ua)) {
        return 'weibo';
    }
    // 7. QQ 浏览器或 QQ 内打开
    if (/qq\//i.test(ua) || /mqqbrowser/i.test(ua)) {
        return 'qq';
    }
    // 8. 支付宝小程序
    if (/alipay|aliapp/i.test(ua)) {
        return 'alipayBrowser';
    }
    // 9. 抖音 / 头条小程序 或 抖音内打开
    if (/tiktok|douyin/i.test(ua)) {
        return 'douyin';
    }
    // 10. 普通移动端 H5（非以上所有平台）
    if (/mobile|android|iphone|ipad|ipod/i.test(ua)) {
        return 'h5';
    }
    // 12. PC端
    return 'other';
}
